// extracted by mini-css-extract-plugin
export default {"assertionScoreDetailsTableContainer":"assertion-score-details-table-container__assertion-score-details-table-container__rO0DC"};